import * as stylex from "@stylexjs/stylex";
import "@/design/tokens.stylex";
import { colors, layout, radii, space, text } from "@/design/tokens.stylex";

// One look for every text field, select and picker trigger: white, a hairline,
// rounded like a chip, and an ink ring on focus.
export const controlStyles = {
  control: {
    kB7OPa: "x9f619",
    k7Eaqz: "xeuugli",
    kAzted: "x19d9pmb",
    kg3NbH: "xtft4pz",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xzbo3x7 xist2jy xajt78",
    kaIpWk: "x16l1o21",
    kWkggS: "x1h1f4i9 x1tjt2ou",
    kMwMTN: "xgwkh9f x1hni2f3",
    kMv6JI: "xjb2p0i",
    kGuDYH: "xtu3avg",
    kLWn49: "x1fc57z9",
    kI3sdo: "x1a2a7pz",
    kGVxlE: "x1gnnqk1 x1hi2w3a",
    k1ekBW: "x12zzom9",
    kIyJzY: "xgdialr",
    kkrTdU: "x1s07b3s",
    k8Qsv1: "x1vblb7q",
    $$css: true
  },
  input: {
    kzqmXN: "xh8yej3",
    $$css: true
  },
  textarea: {
    kzqmXN: "xh8yej3",
    k8WAf4: "xj9id08",
    kHenm0: "x288g5",
    $$css: true
  },
  select: {
    kwRFfy: "x1pmo64r",
    kysU6D: "xjyslct",
    kKwaWg: "xv9por8",
    kz484i: "xiy17q3",
    k1YJky: "x1odsw77",
    $$css: true
  },
  sm: {
    kAzted: "x1kjopne",
    kg3NbH: "x1wa2ap4",
    kGuDYH: "x7x6yu3",
    $$css: true
  },
  invalid: {
    kVAM5u: "xqzc6nl xbp4ppo",
    $$css: true
  }
};